import { AppDispatchType } from '#components/redux/types';
import { Api } from '#src/react/api/Api';
import { InitResponseType as InitResponseByDateType } from '#advertList/api/by-date';
import { InitResponseType as InitResponseByServiceType } from '#advertList/api/by-service';

const apiAdvertListToggleIsFavorite = (
  api: Api,
  id: number,
  cityId: number|null,
  categoryId: number|null,
  nationalityId: number|null,
  areaId: number|null,
  dispatch: AppDispatchType,
): void => {
  dispatch(
    // @ts-ignore
    api.getApiAdvertListByDate().util.updateQueryData(
      'init',
      {
        cityId,
        categoryId,
        nationalityId,
        areaId,
      },
      (draft: InitResponseByDateType) => {
        draft.advertDataList.chunkDataList.forEach((chunkData) => {
          chunkData.adverts.forEach((advert) => {
            if (advert.id === id) {
              advert.isFavorite = !advert.isFavorite;
            }
          });
        });
      },
    ),
  );

  dispatch(
    // @ts-ignore
    api.getApiAdvertListByService().util.updateQueryData(
      'init',
      {
        cityId,
        categoryId,
        nationalityId,
        areaId,
      },
      (draft: InitResponseByServiceType) => {
        draft.advertDataList.chunkDataList.forEach((chunkData) => {
          chunkData.adverts.forEach((advert) => {
            if (advert.id === id) {
              advert.isFavorite = !advert.isFavorite;
            }
          });
        });
      },
    ),
  );
};

export { apiAdvertListToggleIsFavorite };
